import Vue from "vue";
import app from "./app.vue";
import store from "./store";
import router from "./router";
import VueMeta from "vue-meta";
import axios from "axios";

Vue.config.productionTip = false;
Vue.use(VueMeta);

async function initializeCsrfToken() {
    try {
        const response = await axios.get("/TokenCSRF/GetTokenCSRF", {
            baseURL: process.env.VUE_APP_API_BASE_URL,
            withCredentials: true
        });
    } catch (error) {
    }
}

initializeCsrfToken().then(() => {
    new Vue({ router, store, render: (h) => h(app) }).$mount("#app");
});

